import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setIsDialogOpen, setMultiDialogChanged } from "../../actions/dialog";
import { IReduxAppState } from "../../reducers";
import Dialog from "../Dialog";
import { DialogSaveChanges } from "./DialogSaveChanges";

/**General place for handling modal component with redux */
export function DialogComponent(): JSX.Element {
    const { isOpen,
        Component,
        ComponentProps: componentProps,
        dialogTitle,
        styles,
        canClose,
        isFormDialog,
        hasChanged,
        onCloseIcon } = useSelector((state: IReduxAppState) => state.dialog);

    const [isChangedDialogOpen, setIsChangedDialogOpen] = useState(false);

    const dispatch = useDispatch();

    function onClose() {
        if (hasChanged) {
            setIsChangedDialogOpen(true);
        } else {
            onDialogClose();
        }

    }
    function onDialogClose() {
        dispatch(setIsDialogOpen(false));
        if (componentProps?.onClose) {
            componentProps.onClose();
        }
    }
    return <>
        <Dialog
            isOpen={isOpen}
            canClose={canClose}
            title={dialogTitle}
            onClose={onClose}
            styles={styles}
            isFormDialog={isFormDialog}
            onCloseIcon={onCloseIcon}
        >
            {Component !== null ? <Component {...componentProps} onDialogClose={onDialogClose} onClose={onClose} /> : <div></div>}
        </Dialog>
        <DialogSaveChanges
            isOpen={isChangedDialogOpen}
            onClose={() => setIsChangedDialogOpen(false)}
            onCloseAll={() => {
                setIsChangedDialogOpen(false);
                dispatch(setMultiDialogChanged(false));
                onDialogClose();
            }}
        />
    </>;
}